import {
  Create,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "@/components/admin"
import { RaRecord } from "ra-core"
import { ReactElement } from "react"
const RoomEdit = (): ReactElement => {
  const pid = localStorage.getItem("pid")

  return (
    <Create
      title={false}
      className="py-6"
      transform={(data: RaRecord) => {
        const payload = {
          ...data,
          project_id: pid,
        }
        localStorage.removeItem("pid")
        return payload
      }}
      redirect={`/projects/${pid}/edit`}
    >
      <SimpleForm>
        <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-6 xs:grid-cols-6 gap-4 pb-16">
          <ReferenceInput
            source="storey_id"
            reference="storeys"
            filter={{ project_id: pid }}
          >
            <SelectInput optionText="title" />
          </ReferenceInput>
          <TextInput source="title" />
          <TextInput source="description" />
          <SelectInput
            source="type"
            choices={[
              { id: "room", name: "Pièce" },
              { id: "bedroom", name: "Chambre" },
              { id: "kitchen", name: "Cuisine" },
              { id: "wc", name: "Toilettes (WC)" },
              { id: "bathroom", name: "Salle de bain" },
              { id: "garage", name: "Garage" },
            ]}
          />
          <NumberInput source="surface" />
          <NumberInput source="windows" />
          <NumberInput source="balconies" />
          <SelectInput
            source="status"
            choices={[
              { id: 1, name: "Projet enregistré" },
              { id: 2, name: "Phase de conception" },
              { id: 3, name: "Permis et autorisations" },
              { id: 4, name: "Préparation du terrain" },
              { id: 5, name: "Construction des fondations" },
              { id: 6, name: "Structure et charpente" },
              { id: 7, name: "Toiture et extérieur" },
              { id: 8, name: "Installation électrique et plomberie" },
              { id: 9, name: "Travaux intérieurs et finitions" },
              { id: 10, name: "Inspection et conformité" },
              { id: 11, name: "Liste de vérification et corrections finales" },
              { id: 12, name: "Livré" },
            ]}
          />
        </div>{" "}
      </SimpleForm>
    </Create>
  )
}

export default RoomEdit
